import React from "react";
import s from './ButtonText.module.scss'

export const ButtonText = ({onClick = () => {}, value="", disabled , className}) => {
    return <button onClick={onClick} className={s.formButton } disabled={disabled}>{value}</button>
}